import { Link } from "react-router-dom";
import { useState } from "react";
import modalimg from "./assets/images/ModalIMG2.png";
import "./main.css";
import "./responsive.css";
import { AnimatePresence, motion } from "framer-motion";
import { FaTelegramPlane, FaWhatsapp } from "react-icons/fa";

function Links() {
  const [showModal, setShowModal] = useState(false);

  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="container-pro-div">
    

      <section className="first-section">
        <div className="first-section-div">
          <div className="reveal-text">
            <p>Проверка запрета на въезд и срока действия</p>
          </div>
          <Link className="first-section-button-link" to="/main">
            <button className="first-section-button">Отправить запрос</button>
          </Link>

          {/* This button opens the modal */}
          <div className="reveal-text">
            <p>Поставьте недвижимость на учет, по новым правилам (№145-ФЗ)</p>
          </div>
          <button className="first-section-button" onClick={handleOpenModal}>
            ЗАПИСАТЬСЯ НА УСЛУГУ
          </button>
        </div>
      </section>

      {/* Modal */}
      <AnimatePresence>
        {showModal && (
          <div className="modal-overlay" onClick={handleCloseModal}>
            <motion.div
              className="modal-content"
              onClick={(e) => e.stopPropagation()}  
              initial={{ opacity: 1, y: 300 }}
              animate={{ opacity: 1, y: 30 }}
              exit={{ opacity: 0, y: 300 }}
              transition={{ duration: 0.5, ease: "easeOut" }}
            >
              <button className="modal-close" onClick={handleCloseModal}>
                ×
              </button>

              <div className="modal-left">
                <ul className="service-steps">
                  <li>
                    📅 Онлайн-запись на визит в строго определённые даты, с
                    учётом загруженности консульства и сроков обработки
                  </li>
                  <li>
                    ✅ Подготовка пакета документов в соответствии с актуальными
                    требованиями — малейшая ошибка может привести к отказу
                  </li>
                  <li>
                    🤝 Вас встречает наш представитель на личном автомобиле и
                    сопровождает
                  </li>
                  <li>
                    🏛️ Посещение консульства по предварительной записи, с нашим
                    полным сопровождением и разъяснением всех формальностей
                  </li>
                  <li>
                    📑 Подача документов в государственные органы, контроль
                    сроков и отправка оригиналов — строго по регламенту
                  </li>
                  <li>
                    ✅ Получаем необходимое разрешение от органов для оформдения
                    вашей недвижимости
                  </li>
                </ul>
                
                <div className="contact-info">
                  <p>Вы можете связаться с нами через:</p>
                  <p>
                    <strong>Онлайн-чат:</strong> в правом нижнем углу сайта
                  </p>

                  <div className="contact-icons">
                    <a
                      href="https://t.me/Granitsainfo"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaTelegramPlane className="icon telegram-icon" />
                    </a>
                    <a
                      href="https://wa.me/34613150502"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaWhatsapp className="icon whatsapp-icon" />
                    </a>
                  </div>
                </div>
              </div>

              <div className="modal-right">
                <img src={modalimg} alt="Instruction" className="modal-image" />
              </div>
            </motion.div>
          </div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default Links;
